import { DomainError } from "./DomainError";

/**
 * Erro de validação de domínio
 */
export class ValidationError extends DomainError {
  constructor(message: string) {
    super(message);
  }
}
